export type OnboardingGateRole = "candidate" | "employer" | "admin";

export type OnboardingGateInput = {
  isAuthenticated: boolean;
  role: OnboardingGateRole | null;
  onboardingComplete?: boolean | null;
  hasEmployerCompany?: boolean | null;
  path: string;
};

export const DEFAULT_ONBOARDING_ALLOWLIST = [
  "/auth",
  "/logout",
  "/contact",
  "/report-bug",
  "/onboarding",
  "/employer/onboarding",
  "/employer/access",
];

const isAllowedPath = (path: string, allowlist: string[]) =>
  allowlist.some((allowed) => path === allowed || path.startsWith(`${allowed}/`));

export const getOnboardingRedirectPath = (
  input: OnboardingGateInput,
  allowlist: string[] = DEFAULT_ONBOARDING_ALLOWLIST,
) => {
  if (!input.isAuthenticated) return null;
  if (!input.role) return null;
  if (input.role === "admin") return null;
  if (isAllowedPath(input.path, allowlist)) return null;

  if (input.role === "employer") {
    if (input.hasEmployerCompany === false) {
      return "/employer/onboarding";
    }
    return null;
  }

  // Only redirect when we have a definitive false — null (loading/error) must not redirect
  if (input.onboardingComplete === false) {
    return "/onboarding";
  }

  return null;
};
